import index from "../index/de.js"
import login from "../login/de.js"
import projectList from "../projectList/de.js"
import post from "../post/de.js"
import admin from "../admin/de.js"
import outputFile from "../outputFile/de.js"
import dashboard from "../dashboard/de.js"
import explan from "../explan/de.js"

export default {
  index,
  login,
  projectList,
  post,
  admin,
  outputFile,
  dashboard,
  explan
}



// WEBPACK FOOTER //
// ./src/locale/lang/de.js